document.addEventListener("DOMContentLoaded", () => {

  const container = document.querySelector("#inline-product-content");

  if (!container) return;

  const text = container.innerHTML;

  const regex = /\[\[product:([^\]]+)\]\]/g;

  if (!regex.test(text)) {
    console.log("No inline products found");
    return;
  }

  container.innerHTML = text.replace(regex, (match, handle) => {

    return `
      <div class="inline-product-placeholder" data-handle="${handle}">
        Loading product...
      </div>
    `;

  });

  document
    .querySelectorAll(".inline-product-placeholder")
    .forEach(loadProduct);

});


async function loadProduct(element) {

  const handle = element.dataset.handle;

  try {

    const response = await fetch(`/products/${handle}.js`);

    if (!response.ok) {

      element.innerHTML = "Product not found";
      return;

    }

    const product = await response.json();

    const variant = product.variants[0];

    element.innerHTML = `

      <div class="inline-product">

        <img 
          src="${product.featured_image}"
          alt="${product.title}"
          style="max-width:250px">

        <h3>${product.title}</h3>

        <p>
          ${(variant.price / 100).toLocaleString(
            undefined,
            {
              style: "currency",
              currency: "USD"
            }
          )}
        </p>

        <button 
          class="inline-add-button"
          data-variant="${variant.id}">
          Add to Cart
        </button>

      </div>

    `;

  } catch(error) {

    console.error(error);
    element.innerHTML = "Unable to load product";

  }

}


document.addEventListener("click", async (event) => {

  if (!event.target.classList.contains("inline-add-button")) {
    return;
  }

  const variantId = event.target.dataset.variant;

  await fetch("/cart/add.js", {

    method: "POST",

    headers: {
      "Content-Type": "application/json"
    },

    body: JSON.stringify({

      id: variantId,
      quantity: 1

    })

  });


  event.target.innerHTML = "Added ✓";

});